import { QueryOptions } from 'api/clients/InformalFeedbackRequestsClient'

export const informalFeedbackRequestsKeys = {
  prefix: 'informalFeedbackRequests',
  list: (articleKey: string, layerId?: string, options?: QueryOptions) => [
    informalFeedbackRequestsKeys.prefix,
    articleKey,
    layerId ? layerId : 'list',
    layerId ? 'list' : undefined,
    options,
  ],
  detail: (id: number) => [informalFeedbackRequestsKeys.prefix, 'detail', id],
  update: (id: number) => [...informalFeedbackRequestsKeys.detail(id), 'update'],
  close: (id: number) => [...informalFeedbackRequestsKeys.detail(id), 'close'],
  forAlmanacFile: (almanacFileId: string) => [informalFeedbackRequestsKeys.prefix, almanacFileId],
}
